module.exports = __webpack_public_path__ + "img/PackStationheader.8763278a.png";